import { render, staticRenderFns } from "./NoTestApply.vue?vue&type=template&id=2c738032&scoped=true"
import script from "./NoTestApply.vue?vue&type=script&lang=js"
export * from "./NoTestApply.vue?vue&type=script&lang=js"
import style0 from "./NoTestApply.vue?vue&type=style&index=0&id=2c738032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c738032",
  null
  
)

export default component.exports